import { render, staticRenderFns } from "./twoPage.vue?vue&type=template&id=10fe5aac&scoped=true"
import script from "./twoPage.vue?vue&type=script&lang=js"
export * from "./twoPage.vue?vue&type=script&lang=js"
import style0 from "./twoPage.vue?vue&type=style&index=0&id=10fe5aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe5aac",
  null
  
)

export default component.exports